import { defineModelFactory } from '@/app/base/I';
import { Method } from 'axios';

export type RequestModel = {
  url: string,
  method: Method,
  target: string,
  headers?: Record<string, string>,
  params?: Record<string, any>,
  body?: Record<string, any>,
}

export const REQUEST_TARGETS = {
  SVC: 'service', // Сервис
  BITRIX: 'bitrix', // Бус
  LANDER: 'lander', // Лэндер
};

export const requestModel = defineModelFactory<RequestModel>()({
  target: 'service',
});

export const isRequestBodyFilled = (request: RequestModel) => {
  return request.body ? Object.keys(request.body).length > 0 : false;
};
